module.exports = __webpack_public_path__ + "img/25C0.ef994429.svg";